<template>
  <section>
    <div>
      <table :id="tableId" class="table table-bordered table-hover"></table>
    </div>
    <div v-if="this.stateIsLoading">
      <i class="fa fa-refresh fa-spin"></i>
    </div>
    <div v-if="this.stateHasError" class="text-danger" style="padding: 10px">
      <i class="fa fa-exclamation-triangle"></i> Failed to load data. Your session may have expired.
    </div>
  </section>
</template>

<script>
import Details from "../../components/paywall/partner/sections/details/PartnerSubscriptionTermsDetail";
import { mapGetters } from "vuex";
import axios from "axios";
import authHeader from "../../authHeader";
export default {
  data() {
    return {
      tableId: this.randomId(),
      tableRef: null,
      tableData: null,
      tablePaging: true,
      tableDom:
        '<"top"<"row"<"col-md-5"<sB><"info1"i>><"col-md-7"<"search"f>>>t>           <"bottom"<"row"<"col-md-6 ln1"l><"col-md-6 pull-right"p>>>',
      tableScrollY: "",
      stateIsLoading: false,
      stateHasError: false,
    };
  },
  props: {
    isSimple: {
      type: Boolean,
    },
    url: {
      type: String,
      required: true,
    },
    tableColumns: {
      type: Array,
      required: true,
    },
    filteredNames: {
      type: Array,
    },
  },
  computed: {
    ...mapGetters("login", ["loggedInUser"]),
    ...mapGetters("admin", ["currUser", "allOrgs", "allConsortia"]),
  },
  created() {
    // console.log("TableEx created");
  },
  mounted() {
    // console.log("TableEx mounted");
    if (this.isSimple) {
      this.tablePaging = false;
      this.tableDom = '<"top"<"search"f>t>';
      this.tableScrollY = "40vh";
    }
    this.tableRef = null;
    this.refreshTable();
  },
  watch: {
    $route: "refreshTable",
    allOrgs: {
      handler: function (val, oldVal) {
        // console.log("allOrgs", val);
        if (val) {
          this.refreshTable();
        }
      },
      deep: true,
      immediate: true,
    },
    allConsortia: {
      handler: function (val, oldVal) {
        if (val) {
          this.refreshTable();
        }
      },
      deep: true,
      immediate: true,
    },
  },
  components: {
    appDetails: Details,
  },
  methods: {
    randomId() {
      return "ID" + Math.floor(Math.random() * (1000 - 1 + 1)) + 1 + Date.now();
    },
    refreshTable() {
      if (this.url === '/party/organization' || this.url === '/party/consortium') {
        // Vuex-backed tables: use $nextTick to ensure DOM is ready
        // (immediate watchers fire before mounted, when the <table> element doesn't exist yet)
        this.$nextTick(() => {
          this.loadData();
        });
      } else if (!this.tableRef && !this.stateIsLoading) {
        this.loadData();
      }
    },
    loadData() {
      this.stateHasError = false;
      if (this.url == "/party/consortium") {
        if (!this.allConsortia || this.allConsortia.length == 0) {
          return;
        }
        this.tableData = this.allConsortia;
        this.buildTable(this);
      } else if (this.url == "/party/organization") {
        if (this.$store.state.admin.admin.isError) {
          this.stateHasError = true;
          return;
        }
        if (!this.allOrgs || this.allOrgs.length == 0) {
          return;
        }
        this.tableData = this.allOrgs;
        this.buildTable(this);
      } else {
        this.stateIsLoading = true;
        axios
          .get(this.url, { headers: authHeader() })
          .then((response) => {
            this.stateIsLoading = false;
            this.tableData = response.data;
            this.buildTable(this);
          })
          .catch((error) => {
            this.stateIsLoading = false;
            this.stateHasError = true;
            console.error("TableEx fetch error:", error);
          });
      }
    },
    updateData() {
      this.tableData.splice(0, this.tableData.length);
    },
    buildTable(obj) {
      if ($.fn.DataTable.isDataTable("#" + this.tableId)) {
        $("#" + this.tableId).DataTable().destroy();
      }
      this.tableRef = null;
      let table = $("#" + this.tableId).DataTable({
        aaData: this.tableData,
        aoColumns: this.tableColumns,
        paging: this.tablePaging,
        lengthChange: true,
        searching: true,
        ordering: true,
        info: true,
        autoWidth: false,

        scrollY: this.tableScrollY,

        dom: this.tableDom,
        oLanguage: { sSearch: '<i class="fa fa-search text-primary"></i>' },
        buttons: [
          {
            extend: "excel",
            text: '<i class="fa fa-file-excel-o"></i> Excel',
            className: "btn btn-success btn-xs",
          },
          {
            extend: "pdf",
            text: '<i class="fa fa-file-pdf-o"></i> PDF',
            className: "btn bg-primary btn-xs",
          },
          {
            extend: "print",
            text: '<i class="fa fa-print"></i> Print',
            className: "btn btn-warning btn-xs",
          },
          {
            extend: "copy",
            text: '<i class="fa fa-copy"></i> Copy',
            className: "btn btn-danger btn-xs",
          },
        ],
      });
      this.tableRef = table;
      // search input control
      $("div.dataTables_filter input")
        .css({
          // 'width': '90%',
          display: "inline-block",
          border: "1px solid #3b8ab8",
          padding: "5px",
        })
        .attr("placeholder", "Quick search...");

      // to track click event — unbind first so repeated buildTable() calls
      // don't stack delegated handlers on the same tbody (DataTable.destroy()
      // doesn't clear them), which would cause clicks to toggle then untoggle.
      $("#" + this.tableId + " tbody").off("click", "tr").on("click", "tr", function () {
        if ($(this).hasClass("selected")) {
          $(this).removeClass("selected");
          obj.selectedRow = null;
        } else {
          table.$("tr.selected").removeClass("selected");
          $(this).addClass("selected");
          obj.selectedRow = table.row(this).data();
        }

        obj.$emit("rowClicked", obj.selectedRow);
      });
    },
    destroyTable() {
      if (this.tableRef != null) this.tableRef.destroy();
    },
  },
};
</script>

<style scoped>
/* Visual feedback for selected rows */
:deep(.table) tbody tr {
  cursor: pointer;
}
:deep(.table) tbody tr.selected {
  background-color: #d9edf7 !important;
  color: #31708f;
}
:deep(.table) tbody tr.selected td {
  background-color: #d9edf7 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/common/TableEx.vue